// extracted by mini-css-extract-plugin
module.exports = {"desktop":"SDTooltip_desktop__6JS4N","mobile":"SDTooltip_mobile__E1qQN","dialog":"SDTooltip_dialog__RweIc"};